<template>
    <div class="no-collect">
        <img src="../images/personal_center/work-null.png" alt="" />
        <p class="text">你所访问的作品已下架或删除，点击<router-link to="/s-mart/market">市场</router-link>查看其他作品。</p>
    </div>
</template>

<script type="text/javascript">
    export default {
    }
</script>

<style scoped lang="scss" type="text/scss">
.no-collect{
    width: 555px;
    background: #fff;
    border-radius: 3px;
    padding: 50px 0;
    margin: 200px auto 0 auto;
    text-align: center;
    color: #878996;
    font-size: 16px;
    .text{
        margin-top: 25px;
    }
}
</style>


// WEBPACK FOOTER //
// no_collect.vue?57b71404